import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	schemeDashboard: [],
};

const schemesSlice = createSlice({
	name: 'schemes',
	initialState: initialState,
	reducers: {
		setSchemes: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setSchemes, reset } = schemesSlice.actions;

export default schemesSlice.reducer;